(() => {
  const instances = new WeakSet();
  const galleries = new WeakSet();
  const initialize = (root = document) => {
    root.querySelectorAll('.al-pdp-main media-gallery').forEach((gallery) => {
      if (galleries.has(gallery)) return;
      const navigation = gallery.querySelector('[data-al-gallery-navigation]');
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      const slider = viewer?.querySelector('[id^="Slider-Gallery-"]');
      if (!navigation || !slider) return;
      const mediaItems = () => Array.from(slider.children).filter((item, index) =>
        item.matches('.product__media-item[data-media-id]') &&
        (!item.classList.contains('product__media-item--variant') || index === 0)
      );
      navigation.hidden = mediaItems().length < 2;
      navigation.querySelectorAll('[data-al-gallery-step]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const items = mediaItems();
          if (items.length < 2 || typeof gallery.setActiveMedia !== 'function') return;
          const thumbnail = gallery.querySelector('.thumbnail[aria-current="true"]');
          const currentId = thumbnail?.closest('[data-target]')?.dataset.target;
          let currentIndex = items.findIndex((item) =>
            currentId ? item.dataset.mediaId === currentId : item.classList.contains('is-active')
          );
          if (window.matchMedia('(max-width: 749px)').matches) {
            currentIndex = items.reduce((nearest, item, index) =>
              Math.abs(item.offsetLeft - slider.scrollLeft) < Math.abs(items[nearest].offsetLeft - slider.scrollLeft) ? index : nearest
            , 0);
          }
          const nextIndex = (Math.max(0, currentIndex) + Number(button.dataset.alGalleryStep) + items.length) % items.length;
          gallery.setActiveMedia(items[nextIndex].dataset.mediaId, false);
        });
      });
      galleries.add(gallery);
    });
    root.querySelectorAll('[data-al-sticky]').forEach((bar) => {
      if (instances.has(bar)) return;
      const info = document.getElementById('ProductInfo-' + bar.dataset.alSection);
      if (!info) return;
      const button = bar.querySelector('[data-al-sticky-button]');
      const price = bar.querySelector('[data-al-sticky-price]');
      let previousPrice = '';
      let observedButton = null;
      let observer = null;
      const setVisible = (visible) => {
        bar.hidden = !visible;
        document.body.classList.toggle('al-pdp-sticky-visible', visible);
      };
      const synchronize = () => {
        const mainButton = info.querySelector('.product_buy_button_form button[name="add"]');
        const mainPrice = info.querySelector('.price__box_wrapper .price');
        if (!mainButton) {
          setVisible(false);
          return;
        }
        button.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
        const label = mainButton.querySelector('.cart--button-text')?.textContent.trim();
        if (label && button.textContent.trim() !== label) button.textContent = label;
        if (mainPrice && mainPrice.outerHTML !== previousPrice) {
          previousPrice = mainPrice.outerHTML;
          price.replaceChildren(mainPrice.cloneNode(true));
        }
        if (observedButton !== mainButton) {
          observer?.disconnect();
          observedButton = mainButton;
          observer = new IntersectionObserver((entries) => {
            setVisible(entries[0].intersectionRatio < 0.8);
          }, { threshold: [0, 0.8, 1] });
          observer.observe(mainButton);
        }
      };
      button.addEventListener('click', () => {
        const mainButton = info.querySelector('.product_buy_button_form button[name="add"]');
        if (!mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') return;
        mainButton.click();
      });
      synchronize();
      new MutationObserver(synchronize).observe(info, {
        subtree: true, childList: true, characterData: true, attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class', 'value']
      });
      instances.add(bar);
    });
    root.querySelectorAll('.al-pdp-trust a[href="#AlProductDetails"]').forEach((link) => {
      if (link.dataset.alInitialized) return;
      link.dataset.alInitialized = 'true';
      link.addEventListener('click', () => {
        const delivery = document.querySelector('#AlProductDetails .al-pdp-disclosure:last-child');
        if (delivery) delivery.open = true;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', () => {
    if (!document.querySelector('[data-al-sticky]')) document.body.classList.remove('al-pdp-sticky-visible');
  });
})();

(() => {
  const initialized = new WeakSet();
  const initialize = (modal) => {
    if (initialized.has(modal)) return;
    const about = modal.querySelector('.jdgm-write-review-modal__page--about-you');
    const media = modal.querySelector('.jdgm-write-review-modal__page--share-media');
    const aboutForm = about?.querySelector('.jdgm-write-review-modal__form');
    const mediaGroup = media?.querySelector('.jdgm-write-review-modal__form-group--share-media');
    const name = about?.querySelector('#jdgm-name-input');
    const next = modal.querySelector('.jdgm-write-review-modal__nav-btn-next');
    if (!aboutForm || !mediaGroup || !name || !next || modal.querySelector('.jdgm-write-review-modal__compact-body')) return;
    if (modal.querySelector('.jdgm-write-review-modal__page--custom-questions, .jdgm-write-review-modal__page--negative-resolution')) return;
    const nameGroup = name.closest('.jdgm-write-review-modal__field-group');
    const mediaTitle = media.querySelector('.jdgm-write-review-modal__page-header .jdgm-write-review-modal__title');
    nameGroup.parentElement.prepend(nameGroup);
    if (mediaTitle) {
      const label = document.createElement('div');
      label.className = 'jdgm-write-review-modal__field-label';
      label.textContent = mediaTitle.textContent.trim();
      mediaGroup.prepend(label);
    }
    aboutForm.append(mediaGroup);
    modal.classList.add('al-review-flow');
    initialized.add(modal);
    let lastPage = null;
    let armed = false;
    let attempted = false;
    const originalNextText = next.textContent.trim();
    const originalNextLabel = next.getAttribute('aria-label');
    const update = () => {
      const current = modal.querySelector('.jdgm-write-review-modal__page.current-page');
      if (!current) return;
      if (current === about && lastPage !== about) {
        armed = false;
        attempted = false;
      }
      if (current === media && lastPage === about) armed = true;
      const committing = current === media && armed;
      modal.classList.toggle('al-review-media-commit', committing);
      const submitText = window.jdgmSettings?.widget_submit_review_text || originalNextText;
      const desiredText = current === about || committing ? submitText : originalNextText;
      if (current === about || current === media) {
        if (next.textContent.trim() !== desiredText) next.textContent = desiredText;
        const desiredLabel = current === about || committing ? submitText : originalNextLabel;
        if (desiredLabel && next.getAttribute('aria-label') !== desiredLabel) next.setAttribute('aria-label', desiredLabel);
      }
      lastPage = current;
      if (committing && !attempted && !next.disabled && next.getAttribute('aria-disabled') !== 'true') {
        attempted = true;
        queueMicrotask(() => {
          if (modal.isConnected && media.classList.contains('current-page') && !next.disabled) next.click();
        });
      }
    };
    new MutationObserver(update).observe(modal, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-disabled']
    });
    update();
  };
  const discover = () => document.querySelectorAll('.jdgm-write-review-modal').forEach(initialize);
  new MutationObserver(discover).observe(document.body, { childList: true, subtree: true });
  discover();
})();
